import React from 'react';
import { cn } from '@/lib/utils';

type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface SaveStatusIndicatorProps {
  saveStatus: SaveStatus;
  totalWordCount: number;
  currentContent: string;
  initialPrompt?: string;
  initialContent?: string;
}

export function SaveStatusIndicator({
  saveStatus,
  totalWordCount,
  currentContent,
  initialContent,
}: SaveStatusIndicatorProps) {
  let statusText = '';
  let textColor = 'text-muted-foreground';

  switch (saveStatus) {
    case 'saving':
      statusText = 'Saving...';
      break;
    case 'saved':
      statusText = 'Saved';
      textColor = 'text-green-600';
      break;
    case 'error':
      statusText = 'Save Error';
      textColor = 'text-destructive';
      break;
    case 'idle':
      if (initialContent !== undefined && currentContent !== initialContent) {
        statusText = 'Unsaved changes';
        textColor = 'text-muted-foreground';
      } else if (totalWordCount > 0) {
        statusText = 'Saved';
        textColor = 'text-green-600';
      } else {
        statusText = '';
      }
      break;
    default:
      return null;
  }

  if (!statusText && totalWordCount === 0) {
    return null;
  }

  const wordCountText = `${totalWordCount} words`;

  return (
    <span className='flex items-center gap-1.5 text-xs'>
      {statusText && (
        <span className={cn('transition-colors', textColor)}>{statusText}</span>
      )}
      {statusText && <span className='text-muted-foreground'>•</span>}
      <span className='text-muted-foreground'>{wordCountText}</span>
    </span>
  );
}
